import TaskForm from './TaskForm';
import NewUserForm from './NewUserForm';
import EditUserForm from './EditUserForm';
import TagForm from './TagForm';
import NewPlatformForm from './NewPlatformForm';
import EditPlatformForm from './EditPlatformForm';
import TeamTaskForm from './TeamTaskForm';
import EditTeamTaskForm from './EditTeamTaskForm';
import NotificationForm from './NotificationForm';
import NewCronTaskForm from './NewCronTaskForm';
import EditCronTaskForm from './EditCronTaskForm';

export default {
  TaskForm,
  NewUserForm,
  EditUserForm,
  TagForm,
  NewPlatformForm,
  EditPlatformForm,
  TeamTaskForm,
  EditTeamTaskForm,
  NotificationForm,
  NewCronTaskForm,
  EditCronTaskForm,
};
